export default "__VITE_ASSET__oCE9yoFT__"